import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";
import { IBuyFormStateProps } from "types/stores.type";

const useBuyFormStore = create<IBuyFormStateProps>()(
    subscribeWithSelector(
        persist(
            (set, get) => ({
                email: "",
                licencePlate: "",
                cardToken: "",
                usePaymentMethod: "",
                requestedMinutes: null,
                hasLicencePlateWarning: false,
                hasAutoEmail: false,
                isFormValid: false,

                setUsePaymentMethod: (usePaymentMethod) => set({ usePaymentMethod }),

                setEmail: (email) => {
                    set({ email });
                    get().validateForm();
                },

                setLicencePlate: (licencePlate) => {
                    const cleaned = get().cleanLicencePlate(licencePlate);
                    set({ licencePlate: cleaned });
                    get().validateForm();
                },

                setCardToken(cardToken) {
                    set({ cardToken });
                },

                setRequestedMinutes: (requestedMinutes) => {
                    set({ requestedMinutes });
                    get().validateForm();
                },

                setHasLicencePlateWarning: (hasLicencePlateWarning) => set({ hasLicencePlateWarning }),
                setHasAutoEmail: (hasAutoEmail) => set({ hasAutoEmail }),

                validateForm: () => {
                    const { email, licencePlate, requestedMinutes } = get();
                    const emailRegex = /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/;
                    const isEmailValid = emailRegex.test(email);
                    const isLicencePlateValid = licencePlate.length >= 1 && licencePlate.length <= 10;
                    const isMinutesValid = requestedMinutes !== null;

                    const isValid = isEmailValid && isLicencePlateValid && isMinutesValid;
                    set({ isFormValid: isValid });
                    return isValid;
                },

                resetForm: () => {
                    set({
                        email: "",
                        licencePlate: "",
                        cardToken: "",
                        requestedMinutes: null,
                        hasLicencePlateWarning: false,
                        hasAutoEmail: false,
                        isFormValid: false,
                    });
                },

                cleanLicencePlate: (plate) => {
                    return plate
                        .replace(/[\s\-–]/g, "")
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/g, "");
                },
            }),
            {
                name: "buy-form-store",
                partialize: (state) => ({
                    email: state.email,
                    licencePlate: state.licencePlate,
                }),
            }
        )
    )
);

export default useBuyFormStore;
